// extracted by mini-css-extract-plugin
export default {"stars":"Rating_stars__d59hL","star":"Rating_star__ZhvuO","starShow":"Rating_starShow__LdIvb"};